import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaCreditCard,
  FaUniversity,
  FaMoneyBillWave,
  FaChartPie,
} from "react-icons/fa";
import "./Styles.css";

const paymentMethods = [
  { icon: <FaCreditCard />, label: "Credit/Debit Card" },
  { icon: <FaUniversity />, label: "Bank Transfer" },
  { icon: <FaMoneyBillWave />, label: "Cash on Delivery" },
  { icon: <FaChartPie />, label: "Installments" },
];

const PaymentOptions = () => {
  return (
    <Container className="payment-section">
      <Row className="align-items-center">
        {/* Text + Icons Section */}

        <h2>Offering shoppers multiple payment options</h2>
        <Col md={12}>
          <Row>
            {paymentMethods.map((method, index) => (
              <Col md={3} key={index} className="payment-method">
                <div className="icon">{method.icon}</div>
                <p>{method.label}</p>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default PaymentOptions;
